import type { OktaErrorDiagnostics } from 'utils/okta/okta-auth-errors';

import { trackFullStoryEvent } from 'helpers/fullstory';

import { OKTA_LOGIN_EVENT } from './okta-login-analytics.constants';

export const trackOktaCallbackError = (
  diagnostics: OktaErrorDiagnostics
): void => {
  trackFullStoryEvent(OKTA_LOGIN_EVENT.callbackError, { ...diagnostics });
};

interface TrackOktaWidgetErrorArgs {
  controller: string;
  errorName: string;
  statusCode?: number;
  message: string;
}

export const trackOktaWidgetError = ({
  controller,
  errorName,
  statusCode,
  message,
}: TrackOktaWidgetErrorArgs): void => {
  trackFullStoryEvent(OKTA_LOGIN_EVENT.widgetError, {
    controller,
    errorName,
    message,
    ...(statusCode !== undefined && { statusCode }),
  });
};
